module.exports = __webpack_public_path__ + "img/meibi.fef3e5f7.jpg";